<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">Scheduler: Batch Line</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-scan-barcode
                                v-if="hasPerm('scheduling.create')"
                                ref="scan_barcode"
                                scan-object="receiving"
                                header-text="Lookup Warehouse Label"
                                @scanned="scanned_schedule.length > 0 ? setFromScan($event) : getDefaultSchedule($event, true, true, false)"
                                @closed="(scanned_schedule = []), (scanned_qty = [])"
                                @remove="removeFromSelected($event)"
                                :show-default-slot="scanned_schedule.length > 0"
                                scan-label="w"
                                :global="true"
                                :snackbar="false"
                            >
                                <template slot="button">
                                    <v-btn @mouseup.left="setInitialSchedule()" :disabled="scanned_schedule.length == 0" color="success">
                                        {{ $t("lang.continue") }}
                                    </v-btn>
                                </template>
                                <template slot-scope="props" v-if="scanned_schedule.length > 0">
                                    <vue-perfect-scrollbar
                                        class="scroll-area"
                                        :style="$bp.xs ? null : $bp.smallScreen ? 'max-height: calc(100vh - 160px)' : 'max-height: calc(90vh - 160px)'"
                                    >
                                        <v-layout
                                            row
                                            v-for="(item, index) in scanned_schedule"
                                            :key="`schedule-${index}`"
                                            class="schedule-list py-2"
                                            :class="{ 'grey lighten-3': index % 2 == 1 }"
                                        >
                                            <v-flex xs7 my-auto pl-2 pr-1>
                                                {{ item.name }}
                                                <br />
                                                {{ item.receiving_control_id }}
                                                <br />
                                                Qty: {{ item.warehouse_qty }}
                                            </v-flex>
                                            <v-flex xs3 pl-0 pr-3 my-auto>
                                                <v-text-field
                                                    v-model="scanned_qty[index]"
                                                    :label="$t('lang.qty')"
                                                    hide-details
                                                    single-line
                                                    outline
                                                    readonly
                                                    class="center-label qty-full"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs1 my-auto>
                                                <v-btn icon class="mx-0" @click="props.remove(index)">
                                                    <v-icon color="grey lighten-1" class="hover-red-icon">delete</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </vue-perfect-scrollbar>
                                </template>
                            </bc-scan-barcode>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn v-if="hasPerm('warehouse.read') || warehouse_dialog" icon @mouseup.left="getWarehouse(true)">
                                        <v-icon class="material-icons-outlined">warehouse</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t("lang.warehouse") }}
                            </bc-tooltip>
                            <bc-btn-refresh
                                @invoke-method="
                                    startLoader(),
                                        $nextTick(() => {
                                            refresh();
                                            finishLoader(true);
                                        })
                                "
                            ></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : 'py-0'">
                    <v-layout row wrap>
                        <v-flex xs12 sm3 md2 pb-0 pt-0 align-self-start>
                            <v-card class="pa-0 mt-3 mb-0" :class="$bp.xsOnly ? '' : 'mr-3'" style="height: auto">
                                <v-card-text class="pa-0">
                                    <v-layout row wrap inner-layout id="unscheduled_events">
                                        <v-flex xs12 text-center pt-3>
                                            <h2 class="mb-0">Unscheduled</h2>
                                            <v-divider class="mb-0"></v-divider>
                                        </v-flex>
                                        <vue-perfect-scrollbar
                                            v-if="(unscheduled_work_orders || []).length > 0"
                                            :key="update_unscheduled"
                                            class="scroll-area"
                                            :class="{ 'always-show-scroll': $bp.smAndDown }"
                                            :style="$bp.smAndDown ? 'max-height: 300px' : 'max-height: 700px'"
                                            style="width: 100vw !important"
                                            :settings="settings"
                                        >
                                            <v-flex
                                                xs12
                                                pa-3
                                                v-for="(order, i) in unscheduled_work_orders"
                                                :key="i"
                                                class="rounded striped-odd unselectable draggable-event"
                                                :class="hasPerm('scheduling.create') ? 'cursor-move hoverable pack-event' : 'no-hover'"
                                                :data-event="prepOrderForDrag(order)"
                                                :data-id="order.work_order_id"
                                                @mouseup.left="openUnscheduled(order)"
                                            >
                                                <v-layout row wrap inner-layout>
                                                    <v-flex xs12 pa-0>{{ order.name }}</v-flex>
                                                    <v-flex xs12 pa-0>{{ order.customer_part_number }}</v-flex>
                                                    <v-flex xs12 fs-14 row pa-0 v-if="order.batch_count || order.batch_qty"
                                                        >{{ order.batch_count ? `${order.batch_count} Batch${order.batch_count > 1 ? "es" : ""}` : ""
                                                        }}{{ order.batch_count && order.batch_qty ? " / " : ""
                                                        }}{{ order.batch_qty ? `${order.batch_qty} Parts` : "" }}</v-flex
                                                    >
                                                    <v-flex xs12 fs-12 pa-0 v-if="order.company">{{ order.company }}</v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </vue-perfect-scrollbar>
                                        <v-flex v-else xs12 pa-3 class="grey lighten-2"> No unscheduled events </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm9 md10 align-self-start pt-3>
                            <v-layout row class="mb-3">
                                <v-flex xs12>
                                    <div class="d-grid">
                                        <div>
                                            <v-btn
                                                dark
                                                class="ma-0"
                                                style="border-radius: 2px 0px 0px 2px; min-width: 45px !important"
                                                @click="changeDateRange('prev')"
                                            >
                                                <v-icon>chevron_left</v-icon>
                                            </v-btn>
                                            <v-btn
                                                dark
                                                class="ma-0"
                                                style="border-radius: 0px 2px 2px 0px; min-width: 45px !important"
                                                @click="changeDateRange('next')"
                                            >
                                                <v-icon>chevron_right</v-icon>
                                            </v-btn>
                                            <v-btn class="ml-2 ma-0" dark style="text-transform: capitalize" @click="changeDateRange('today')">Today</v-btn>
                                            <v-btn class="ml-2 ma-0" dark style="text-transform: capitalize" @click="openDateSelect()">Select Date</v-btn>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <!-- <bc-charts chart-type="gantt" :chart-data="true"></bc-charts> -->
                            <div id="dp" ref="scheduler"></div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <bc-dialog :value="schedule_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ show_add ? "Schedule Work Order" : "Select Work Order" }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeScheduleDialog"
                            :dialog-status="schedule_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="orders">
                            <v-container grid-list-form>
                                <v-layout row wrap v-if="show_add">
                                    <v-flex class="pa-1">{{ current_order.name }}</v-flex>
                                    <v-flex class="pa-1">{{ `Qty: ${current_order.qty}` }}</v-flex>
                                    <v-flex class="pa-1">{{ current_order.company }}</v-flex>
                                    <v-flex class="pa-1">{{ `Received on ${current_order.date_received}` }}</v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-date-picker v-model="start_date" label="Start Date" @update="start_date = $event"></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-time-picker v-model="start_time" label="Start Time" @update="start_time = $event"></bc-time-picker>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-date-picker v-model="end_date" label="End Date" @update="end_date = $event"></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-time-picker v-model="end_time" label="End Time" @update="end_time = $event"></bc-time-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete label="Machine *" :items="machines || []"></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea label="Notes" auto-grow rows="1"></v-textarea>
                                    </v-flex>
                                </v-layout>
                                <vue-perfect-scrollbar v-else class="scroll-area" :style="$bp.xs ? null : 'max-height: calc(100vh - 150px)'">
                                    <v-list two-line class="dropdown-list">
                                        <template v-for="(order, index) in unscheduled_work_orders">
                                            <div :key="index" v-if="index < 5">
                                                <v-divider v-if="index > 0" class="ma-0 grey lighten-1"></v-divider>
                                                <v-list-tile
                                                    v-ripple
                                                    class="clickable text-xs-center headline"
                                                    :class="{ 'list-hover': !$bp.smallScreen }"
                                                    @click="setCurrentOrder(order)"
                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                            v-html="'Batch ' + (index + 1) + ': ' + order.name"
                                                            class="fw-bold"
                                                        ></v-list-tile-title>
                                                        <v-list-tile-sub-title
                                                            v-html="'Recieved: ' + order.date_received + ' from ' + order.company + ' ' + ''"
                                                        ></v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </div>
                                        </template>
                                    </v-list>
                                </vue-perfect-scrollbar>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="show_add" color="secondary" @mouseup.left="show_add = false">Go Back</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeScheduleDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn v-if="show_add" color="success">Add To Schedule</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="warehouse_dialog" :max-width="current_part ? 800 : 1000">
                <v-card>
                    <v-card-title style="margin-bottom: 0px !important">
                        <span class="headline">{{ current_part ? $t("lang.create_batch") : $t("lang.warehouse") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeWarehouseDialog"
                            :dialog-status="warehouse_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text :class="{ 'pa-0': !current_part, 'prevent-click': !hasPerm('scheduling.create') }" style="margin: 0px !important">
                        <v-form ref="schedule" v-if="current_part" @submit.prevent>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12 sm5 align-self-start pa-0>
                                        <vue-perfect-scrollbar
                                            class="scroll-area"
                                            :style="$bp.xs ? null : this.$bp.smallScreen ? 'max-height: calc(100vh - 220px)' : 'max-height: calc(90vh - 220px)'"
                                        >
                                            <v-layout
                                                row
                                                v-for="(item, index) in schedule"
                                                :key="`schedule-${index}`"
                                                class="schedule-list py-2 clickable"
                                                :class="{ 'grey lighten-3': index % 2 == 1 }"
                                                @mouseup.left="setScheduleValue(item.warehouse_qty, index)"
                                            >
                                                <v-flex xs9 my-auto pl-2 pr-1>
                                                    {{ item.name }}
                                                    <br />
                                                    {{ item.receiving_control_id }}
                                                    <br />
                                                    Qty: {{ item.warehouse_qty }}
                                                </v-flex>
                                                <v-flex xs3 pl-0 pr-3 my-auto>
                                                    <v-text-field
                                                        v-model="schedule_qty[index]"
                                                        :label="$t('lang.qty')"
                                                        hide-details
                                                        single-line
                                                        outline
                                                        class="center-label"
                                                        :class="
                                                            +schedule_qty[index] > +schedule[index].warehouse_qty ||
                                                            (schedule_qty[index] != '' && !Number.isInteger(+schedule_qty[index])) ||
                                                            (schedule_qty[index] != '' && +schedule_qty[index] < 0)
                                                                ? 'qty-error'
                                                                : +schedule_qty[index] == +schedule[index].warehouse_qty
                                                                ? 'qty-full'
                                                                : +schedule_qty[index] > 0
                                                                ? 'qty-partial'
                                                                : null
                                                        "
                                                        :rules="ifValid([...$r.min_value(0), ...$r.max_value(item.warehouse_qty), ...$r.integer()])"
                                                        @mouseup.left.stop=""
                                                        type="number"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </vue-perfect-scrollbar>
                                        <v-flex d-inline-flex>
                                            <v-btn color="error" @mouseup.left="schedule_qty = Array(schedule.length).fill('')"> Set to zero </v-btn>
                                            <v-btn color="primary" @mouseup.left="autoFillBatches()"> Fill batch </v-btn>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs12 sm7 align-self-start :class="{ 'pl-3 pt-2': $bp.smAndUp }">
                                        <h1>{{ current_part.name }}</h1>
                                        <h1>{{ current_part.customer_part_number }}</h1>
                                        <h1>{{ current_part.company }}</h1>
                                        <v-layout row wrap class="pt-3">
                                            <v-flex pa-0 xs8>
                                                <h3>Batch Size</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs4>
                                                <h3 class="text-center">{{ current_part.batch_size }}</h3>
                                            </v-flex>
                                            <v-flex xs8 py-0> </v-flex>
                                            <v-flex xs4 py-0>
                                                <v-divider class="mt-0"></v-divider>
                                            </v-flex>
                                            <v-flex pa-0 xs8>
                                                <h3>Total Batches</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs4>
                                                <h3 class="text-center" :style="{ color: total_batches > 1 ? 'red' : '' }">{{ total_batches }}</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs12 mb-3>
                                                <v-divider class="my-0"></v-divider>
                                            </v-flex>
                                            <v-flex xs12 v-for="i in Object.keys(slug_group).length" :key="'station-' + i">
                                                <v-layout row>
                                                    <v-flex pa-0 xs4 my-auto>
                                                        <h4 class="mb-0">{{ filtered_group[Object.keys(filtered_group)[i - 1]][0].station }}</h4>
                                                    </v-flex>
                                                    <v-flex pa-0 xs8>
                                                        <v-select
                                                            v-model="station_options[i - 1]"
                                                            :label="$t('lang.station_id')"
                                                            :items="slug_group[filtered_group[Object.keys(filtered_group)[i - 1]][0].slug] || []"
                                                            item-value="part_station_id"
                                                            item-text="label"
                                                            class="pt-0 mb-0"
                                                            hide-details
                                                            single-line
                                                        ></v-select>
                                                    </v-flex>
                                                    <!-- {{ i }} {{ Object.keys(filtered_group) }} {{ Object.keys(filtered_group)[i-1] }} -->
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                        <v-data-table
                            v-else
                            :headers="warehouse_headers"
                            :items="warehouse || []"
                            :no-data-text="$t('lang.no_results_matching')"
                            hide-actions
                            :must-sort="true"
                            :pagination.sync="warehouse_default_sort"
                        >
                            <template slot="items" slot-scope="props">
                                <tr
                                    class="clickable"
                                    @mouseup.left="
                                        props.item.has_part_process_error == '1' || !props.item.furnace_options
                                            ? openPartErrorDialog(props.item)
                                            : getDefaultSchedule(props.item)
                                    "
                                >
                                    <td class="text-center">
                                        <v-icon v-if="props.item.days_aged_icon" :color="props.item.days_aged_class">{{ props.item.days_aged_icon }}</v-icon>
                                    </td>
                                    <td class="text-center">{{ props.item.days_aged }}</td>
                                    <td>{{ props.item.company }}</td>
                                    <td :class="props.item.has_part_process_error == '1' || !props.item.furnace_options ? 'red--text' : ''">
                                        {{ props.item.customer_part_number }}
                                    </td>
                                    <td>{{ props.item.name }}</td>
                                    <td class="text-center">{{ props.item.warehouse_qty }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions v-if="current_part">
                        <v-btn color="secondary" @mouseup.left="back_to_warehouse ? (current_part = null) : openBarcode(true)">
                            <v-icon class="mr-1">keyboard_return</v-icon>
                            {{ $t("lang.back") }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeWarehouseDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            @mouseup.left="scheduleBatch()"
                            :disabled="station_options.includes(null || undefined) || total_batches <= 0 || total_batches > 1"
                            color="success"
                        >
                            {{ $t("lang.save") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="part_process_error_dialog">
                <v-card>
                    <v-card-title class="red-dialog-title">
                        <span class="headline">Incomplete Process</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="part_process_error_dialog"
                            :dialog-status="part_process_error_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12
                                    >This part has a process that is not properly set up. To schedule this part please visit the part profile and complete the
                                    process.</v-flex
                                >
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="part_process_error_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            v-if="part_with_error"
                            color="primary"
                            @mouseup.left="$router.push({ name: 'part_profile', params: { id: part_with_error.part_id, tab: 'process' } })"
                            >Go to part</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <v-dialog ref="dialog" v-model="select_date_dialog" :return-value="select_date" persistent lazy full-width width="290px">
                <v-date-picker v-model="select_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="select_date_dialog = false">Cancel</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="$route.query.start_date ? convertTimestampToDate($route.query.start_date) == select_date : false"
                        @click="customButtonAction('gotoDate')"
                    >
                        OK
                    </v-btn>
                </v-date-picker>
            </v-dialog>
            <bc-dialog v-if="calendar_event_dialog" :value="calendar_event_dialog" max-width="800">
                <v-card>
                    <v-card-title>
                        <span class="headline" v-if="current_event"
                            >{{ current_event.start }}
                            -
                            {{ current_event.end }}</span
                        >
                        <span class="headline" v-else>Not Scheduled</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="calendar_event_dialog"
                            :dialog-status="calendar_event_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-layout row wrap class="pb-3 px-2">
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.part_name") }}</span>
                                <h3>{{ current_event_props.name ? current_event_props.name : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.customer_part_number") }}</span>
                                <h3>{{ current_event_props.customer_part_number ? current_event_props.customer_part_number : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.company") }}</span>
                                <h3>{{ current_event_props.company ? current_event_props.company : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.batch_qty") }}</span>
                                <h3>{{ current_event_props.batch_qty ? current_event_props.batch_qty + " Qty" : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.pattern_number") }}</span>
                                <h3>{{ current_event_props.pattern_number ? current_event_props.pattern_number : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.batch_count") }}</span>
                                <h3>
                                    {{
                                        current_event_props.batch_count
                                            ? current_event_props.batch_count + (current_event_props.batch_count == "1" ? " Batch" : " Batches")
                                            : "---"
                                    }}
                                </h3>
                            </v-flex>
                        </v-layout>
                        <v-layout
                            row
                            class="border-bottom-2"
                            :style="!$bp.smallScreen ? 'max-height: 525px;' : ''"
                            v-if="current_event_props.work_orders_batches"
                        >
                            <v-flex xs12 pa-0 :style="!$bp.smallScreen ? 'overflow: auto' : ''">
                                <v-data-table
                                    :headers="batch_headers"
                                    :items="current_event_props.work_orders_batches"
                                    item-key="batch_id"
                                    :no-data-text="$t('lang.no_results_matching')"
                                    hide-actions
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr class="clickable" @mouseup.left="goToBatch(props.item)">
                                            <td class="px-1 text-center">{{ props.item.batch_control_id }}</td>
                                            <td class="px-1 text-center">{{ props.item.batch_size ? props.item.batch_size : "" }}</td>
                                            <td class="px-1 text-center">{{ props.item.start }}</td>
                                            <td class="px-1 text-center">{{ props.item.current_station }}</td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="error"
                            @mouseup.left="$refs.unscheduleDialog.openDialog()"
                            v-if="current_event && current_event_props.has_completed_furnace == '0' && hasPerm('scheduling.delete')"
                            >Unschedule</v-btn
                        >
                        <v-btn color="error" @mouseup.left="$refs.deleteDialog.openDialog()" v-else-if="!current_event && hasPerm('scheduling.delete')"
                            >Delete</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn v-if="current_event" color="primary" @mouseup.left="dev_mode ? showPrinter('print_4x6_label') : printLabel('print_4x6_label')">
                            {{ $t("lang.print_label") }}
                        </v-btn>
                        <v-btn
                            v-if="current_event"
                            color="primary"
                            @mouseup.left="dev_mode ? showPrinter('print_process_sheet') : printLabel('print_process_sheet')"
                        >
                            {{ $t("lang.print_process_sheet") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="unscheduleDialog"
                :headline="$t('lang.unschedule')"
                :message="$t('lang.confirm_unschedule_header')"
                @onConfirm="onUnscheduleConfirm"
            ></delete-confirmation-dialog>
            <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
            <bc-modal-override ref="override" @eventname="scheduleBatch"></bc-modal-override>
        </v-container>
    </div>
</template>

<script>
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { toMoment } from "@fullcalendar/moment"; // only for formatting
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import { mapActions, mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";
import { DayPilot, DayPilotScheduler } from "daypilot-pro-vue";

export default {
    components: {
        DayPilotScheduler,
    },
    data() {
        return {
            start_time: null,
            start_date: null,
            end_time: null,
            end_date: null,
            current_order: null,
            schedule_dialog: false,
            show_add: false,
            search_date: null,
            line_view: "batch",
            headers: [
                { text: this.$t("lang.production_line"), sortable: false, width: "33%" },
                { text: this.$t("lang.machine_name"), sortable: false, width: "33%" },
                { text: this.$t("lang.short_code"), sortable: false, width: "33%" },
            ],
            warehouse_headers: [
                { text: "", sortable: false, width: "5%" },
                { text: this.$t("lang.aged"), value: "days_aged", width: "10%", align: "center" },
                { text: this.$t("lang.customer"), value: "company", width: "25%" },
                { text: this.$t("lang.part_number_short"), value: "customer_part_number", width: "15%" },
                { text: this.$t("lang.part_name"), value: "name", width: "30%" },
                { text: this.$t("lang.warehouse_qty"), value: "warehouse_qty", width: "15%", align: "center" },
                // { text: '', sortable: false, width: '15%' },
            ],
            batch_headers: [
                { text: this.$t("lang.control_id"), value: "batch_control_id", align: "center" },
                { text: this.$t("lang.qty"), value: "batch_size", align: "center" },
                { text: this.$t("lang.start"), value: "start", align: "center" },
                { text: this.$t("lang.current_station"), value: "current_station", align: "center" },
            ],
            warehouse_default_sort: {
                descending: true,
                sortBy: "days_aged",
                rowsPerPage: -1,
            },
            machine: {
                line_id: "",
                machine_name: "",
                short_code: "",
            },
            current_obj: null,
            filter: {
                search: "",
                line_id: "",
                page_size: 0,
                page_num: 0,
            },
            machine_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showMachine" },
                { title: this.$t("lang.refresh"), action: "dbGetMachines" },
            ],
            scanned_schedule: [],
            current_part: null,
            back_to_warehouse: true,
            warehouse_dialog: false,
            part_process_error_dialog: false,
            part_with_error: null,
            selected_wo: [],
            schedule_qty: [],
            scanned_qty: [],
            select_date_dialog: false,
            select_date: null,
            update_unscheduled: 0,
            scanned_schedule: [],
            settings: {
                suppressScrollX: true,
            },
            schedulerChart: null,
            calendar_event_dialog: false,
            current_event: null,
            current_event_props: {
                work_orders_batches: [],
            },
            current_part: null,
            file_name: null,
            confirm_override_dialog: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.startLoader();
            vm.$router.push({ query: { start_date: Math.floor(new Date() / 1000), end_date: Math.floor(new Date() / 1000 + 86400) } });
            vm.$store.commit("toggleMainMenu", false);
            vm.finishLoader();
        });
        // let parsedQuery = JSON.parse(JSON.stringify(to.query));
        // store.dispatch(
        //     "fetchMachines",
        //     {
        //         url: 'machines',
        //         method: 'get',
        //         stateProperty: 'machines',
        //         commit: true,
        //         body: parsedQuery
        //     }
        // ).then((data) => {
        //     if (typeof(data) !== 'undefined' && data.machines)
        //     {
        //         next(vm => {
        //             vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
        //             vm.finishLoader();
        //         })
        //     }else{
        //         next({ name: 'dashboard', replace: true });
        //     }
        // })
        // next((vm) => {
        //     vm.search_date = vm.current_day;
        //     vm.finishLoader();
        // });
    },
    beforeRouteUpdate(to, from, next) {
        // let parsedQuery = JSON.parse(JSON.stringify(to.query));
        // this.$store.dispatch(
        //     "fetchMachines",
        //     {
        //         url: 'machines',
        //         method: 'get',
        //         stateProperty: 'machines',
        //         commit: true,
        //         body: parsedQuery
        //     }
        // ).then((data) => {
        //     if (typeof(data) !== 'undefined' && data.machines)
        //     {
        //         this.setQuery(parsedQuery, this.filter, this.default_filter);
        //         this.finishLoader();
        //         next()
        //     }else{
        //         next({ name: 'dashboard', replace: true });
        //     }
        // })
        this.search_date = this.current_day;
        next(this.finishLoader());
    },
    computed: {
        ...mapState({
            warehouse: (state) => state.work_orders.warehouse,
            machines: (state) => state.machines.machines,
            production_lines: (state) => state.production.production_lines,
            unscheduled_work_orders: (state) => state.work_orders.unscheduled_work_orders,
            schedule: (state) => state.work_orders.schedule,
            machines: (state) => state.machines.machines,
        }),
        total_qty() {
            return _.sumBy(this.schedule_qty || [], (qty) => +qty);
        },
        total_batches() {
            let total = 0;
            if (this.current_part && !!(+this.total_qty / +this.current_part.batch_size)) {
                total = Math.ceil((+this.total_qty / +this.current_part.batch_size) * 1000) / 1000;
            }
            return Math.max(total, 0);
        },
        partial_batch() {
            if (!this.current_part || !this.total_qty) return 0;
            return Math.ceil((this.total_batches * 1000) % 1000) / 10;
        },
    },
    methods: {
        ...mapActions(["saveBatchToSchedule", "fetchBatchSchedule", "removeBatchFromSchedule"]),
        setCurrentOrder(order) {
            this.current_order = order;
            this.show_add = true;
        },
        closeScheduleDialog() {
            this.schedule_dialog = false;
            this.show_add = false;
        },
        getWarehouse(status = true) {
            if (status) {
                this.$store.commit("toggleModalLoader", true);
                this.warehouse_dialog = true;
                this.back_to_warehouse = true;
            }
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "warehouse?line_id=1",
                    method: "get",
                    stateProperty: "warehouse",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        closeWarehouseDialog() {
            this.warehouse_dialog = false;
            this.current_part = null;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
            this.scanned_schedule = [];
            this.scanned_qty = [];
        },
        openPartErrorDialog(part) {
            this.part_with_error = part;
            this.part_process_error_dialog = true;
        },
        getDefaultSchedule(part = null, fill_batches = true, from_scan = false, to_warehouse = true) {
            if (part) {
                if (from_scan && !this.$refs.scan_barcode.barcode_dialog) this.$refs.scan_barcode.barcode_dialog = true;
                this.back_to_warehouse = to_warehouse;
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: `warehouse/by_part_id/${part.part_id}/1`,
                        method: "get",
                        stateProperty: "schedule",
                        dataProperty: "parts.warehouse",
                        commit: true,
                    })
                    .then((data) => {
                        if (typeof data != "undefined" && data.parts) {
                            this.current_part = data.parts;

                            if (from_scan) {
                                let found_scan = data.parts.warehouse.filter((w) => w.receiving_id == part.receiving_id)[0];
                                this.$refs.scan_barcode.deactivateBarcode();
                                this.$refs.scan_barcode.setLoader(false);
                                if (found_scan && this.current_part.parts_stations) {
                                    this.scanned_schedule.push(found_scan);
                                    this.scanned_qty.push(+found_scan.warehouse_qty);
                                } else {
                                    this.createAlert("error", "scan_again");
                                    this.current_part = null;
                                    return;
                                }
                            }

                            this.current_warehouse = part;
                            this.grouped_stations = {};
                            this.station_options = [];
                            if (data.parts.parts_stations) {
                                this.grouped_stations = _.groupBy(data.parts.parts_stations, "sort_order");
                                let filter_group = JSON.parse(JSON.stringify(this.grouped_stations));
                                let slug_group = {};
                                for (const [key, value] of Object.entries(filter_group)) {
                                    // for (let j=0; j < value.length; j++) { if(value[j].slug == 'setting'){ value.splice(j,1) } }
                                    if (value.length == 0) {
                                        delete filter_group[key];
                                    } /* else if(value.length == 1) {
                                        this.station_options.push(value[0].part_station_id)
                                    } */ else {
                                        let group = {};
                                        if (fill_batches) {
                                            group = value.filter((e) => e.prime == "1");
                                            if (group && group.length > 0) {
                                                this.station_options.push(group[0].part_station_id);
                                            } else {
                                                this.station_options.push(value[0].part_station_id);
                                            }
                                        } else {
                                            if (value.length > 1) {
                                                let slug = value[0].slug;
                                                group = value.filter(
                                                    (e) =>
                                                        e.short_code == this.current_batch[`${slug}`] &&
                                                        e.pattern_number == this.current_batch[`${slug}_pattern`]
                                                )[0];
                                                this.station_options.push(group.part_station_id);
                                            } else {
                                                group = value[0];
                                                this.station_options.push(group.part_station_id);
                                            }
                                        }
                                        slug_group[group[0].slug] = value;
                                    }
                                }
                                this.slug_group = slug_group;
                                this.filtered_group = filter_group;
                            }
                            if (fill_batches && data.parts.warehouse) {
                                this.schedule_qty = Array(data.parts.warehouse.length).fill("");
                            }
                            if (fill_batches && !from_scan && +part.warehouse_qty != +data.parts.warehouse_qty) {
                                if (+data.parts.warehouse_qty == 0) {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "delete",
                                        id: data.parts.part_id,
                                        pk: "part_id",
                                    });
                                } else {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "patch",
                                        id: data.parts.part_id,
                                        pk: "part_id",
                                        with: {
                                            batched_qty: data.parts.batched_qty,
                                            warehouse_qty: data.parts.warehouse_qty,
                                            received_qty: data.parts.received_qty,
                                        },
                                    });
                                }
                            }

                            if (fill_batches && +data.parts.warehouse_qty > 0 && data.parts.batch_size) {
                                this.autoFillBatches();
                            } else {
                                this.current_part = null;
                                this.$store.commit("toggleModalLoader", false);
                            }
                        }
                    })
                    .finally(() => {
                        this.$store.commit("validationOn");
                        this.$store.commit("toggleModalLoader", false);
                        if (from_scan) this.$refs.scan_barcode.activateBarcode();
                    });
            }
        },
        autoFillBatches() {
            let curr_index = 0;
            let curr_warehouses = this.schedule.map((a) => a.warehouse_qty);
            let batch_size = +this.current_part.batch_size;
            let batches_needed = Math.floor(+this.current_part.warehouse_qty / batch_size);
            this.schedule_qty = Array(this.schedule.length).fill("");
            let total_qty = 0;
            for (let k = 0; k < curr_warehouses.length; k++) {
                // if curr_warehouses[k] > batch_size, set schedule_qty[k] to batch_size and the rest to 0 and then return
                if (curr_warehouses[k] >= batch_size) {
                    this.schedule_qty[k] = batch_size - total_qty;
                    curr_warehouses[k] = curr_warehouses[k] - batch_size;
                    total_qty += +this.schedule_qty[k];
                } else {
                    curr_warehouses[k] = 0;
                    this.schedule_qty[k] = curr_warehouses[k];

                    total_qty += +curr_warehouses[k];
                }
            }

            // for (let x = 0; x < batches_needed; x++) {
            //     let skip = false;
            //     let current_batch = 0;
            //     for (let k = 0; k < curr_warehouses.length && !skip && current_batch < batch_size; k++) {
            //         if (curr_warehouses[k] > 0) {
            //             let w = curr_warehouses[k];
            //             if (this.schedule_qty[curr_index] == "") this.schedule_qty[curr_index] = 0;
            //             if (current_batch + +w <= batch_size) {
            //                 this.schedule_qty[curr_index] += +w;
            //                 curr_warehouses[k] = 0;
            //                 current_batch += +w;
            //                 if (this.schedule_qty[curr_index] == batch_size) {
            //                     skip = true;
            //                 }
            //                 curr_index++;
            //             } else {
            //                 let num_to_pull = batch_size - current_batch;
            //                 current_batch += +num_to_pull;
            //                 this.schedule_qty[curr_index] = this.schedule_qty[curr_index] + num_to_pull;
            //                 curr_warehouses[k] = +w - num_to_pull;
            //                 if (w == 0) curr_index++;
            //                 skip = true;
            //             }
            //         }
            //     }
            // }
            this.schedule_qty = this.schedule_qty.map(String);
        },
        setScheduleValue(qty, index) {
            this.$set(this.schedule_qty, index, qty);
        },
        setFromScan(scan) {
            let found_scan = null;
            if (scan && scan.receiving_id) {
                found_scan = this.schedule.filter((w) => w.receiving_id == scan.receiving_id)[0];
                if (found_scan && this.scanned_schedule.filter((s) => s.receiving_id == scan.receiving_id).length == 0) {
                    this.scanned_schedule.push(found_scan);
                    this.scanned_qty.push(+found_scan.warehouse_qty);
                } else {
                    found_scan = null;
                }
            }
            if (!found_scan) {
                this.createAlert("error", "scan_again");
            }
            this.$refs.scan_barcode.resetBarcode();
        },
        openDateSelect() {
            this.select_date_dialog = true;
        },
        customButtonAction(action) {
            this.select_date_dialog = false;
            let one_day = 60 * 60 * 24;
            let new_start_date = new Date(this.select_date).getTime() / 1000;
            let chart_start_date = new Date(new_start_date * 1000);

            this.$nextTick(() => {
                this.$router.push({
                    name: this.$route.name,
                    query: {
                        start_date: new_start_date,
                        end_date: new_start_date + one_day,
                    },
                    params: {
                        loader: false,
                    },
                });
                this.schedulerChart.update({ startDate: new DayPilot.Date(chart_start_date), days: 2 });
                this.getBatchSchedule();
                // udpate date picker if other button is used
            });
            // let one_day = 60 * 60 * 24;
            // if (this.$refs.calendar) {
            //     let cal_api = this.$refs.calendar.getApi();
            //     let current_start = cal_api.view.currentStart.getTime() / 1000;
            //     let new_start_date = null;

            //     if (action == "next") {
            //         new_start_date = current_start + one_day;
            //     } else if (action == "prev") {
            //         new_start_date = current_start - one_day;
            //     } else if (action == "today") {
            //         let today_unix =
            //             new Date(
            //                 new Date().toLocaleString("en-US", { timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York" })
            //             ).setHours(0, 0, 0, 0) / 1000;
            //         new_start_date = today_unix;
            //     } else if (action == "gotoDate") {
            //         // 'gotoDate' puts the date in the middle if three day view, adjust start_date by one day
            //         new_start_date = this.convertDateToTimestamp(this.select_date) + one_day * 2;
            //         this.select_date_dialog = false;
            //     }
            //     // for 'gotoDate' pass along date, other actions dont have parameter
            //     cal_api[action](new_start_date * 1000);

            //     this.$nextTick(() => {
            //         this.$router.push({
            //             name: this.$route.name,
            //             query: {
            //                 furnace_option: this.$route.query.furnace_option ? this.$route.query.furnace_option : null,
            //                 start_date: new_start_date,
            //             },
            //             params: {
            //                 loader: false,
            //             },
            //         });
            //         // udpate date picker if other button is used
            //         if (action != "gotoDate") {
            //             this.select_date = this.convertTimestampToDate(new_start_date);
            //         }
            //     });
            // }
        },
        convertDateToTimestamp(date) {
            let new_date = new Date(
                new Date(date).toLocaleDateString("fr-CA", { timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York" })
            ).setHours(0, 0, 0, 0);
            return new_date / 1000;
        },
        convertTimestampToDate(timestamp) {
            return new Date(timestamp * 1000).toLocaleDateString("fr-CA", {
                timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        scheduleBatch(ignore_override = false) {
            // alert('schedule')
            if (this.validateForm("schedule")) {
                let batches = [];
                this.schedule.forEach((s, i) => {
                    // only send if a qty is entered
                    if (!!this.schedule_qty[i] && +this.schedule_qty[i] > 0) {
                        batches.push({
                            receiving_id: s.receiving_id,
                            batch_qty: this.schedule_qty[i],
                        });
                    }
                });

                if (batches.length > 1 && ignore_override == false) {
                    this.$refs.override.openDialog();
                } else {
                    let schedule_obj = {
                        company_id: this.current_part.company_id,
                        part_id: this.current_part.part_id,
                        part_station_id: this.station_options,
                        batches: batches,
                    };
                    this.$store.commit("toggleModalLoader", true);
                    this.$store
                        .dispatch("fetchWorkOrder", {
                            url: "work_orders",
                            method: "post",
                            stateProperty: "work_orders_batches",
                            mutate: true,
                            body: schedule_obj,
                        })
                        .then((data) => {
                            if (data && data.code == "200") {
                                this.getUnscheduled();
                                if (+this.current_part.warehouse_qty - this.total_qty > 0) {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "patch",
                                        id: data.work_orders_batches[0].part_id,
                                        pk: "part_id",
                                        with: {
                                            part_id: data.work_orders_batches[0].part_id,
                                            warehouse_qty: (+this.current_part.warehouse_qty - this.total_qty).toString(),
                                            batched_qty: (+this.current_part.batched_qty + this.total_qty).toString(),
                                        },
                                    });
                                } else if (+this.current_part.warehouse_qty - this.total_qty == 0) {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "delete",
                                        id: data.work_orders_batches.part_id,
                                        pk: "part_id",
                                    });
                                }
                                this.scanned_schedule = [];
                                this.scanned_qty = [];
                                this.warehouse_dialog = false;
                                this.confirm_schedule_dialog = false;
                                setTimeout(() => {
                                    this.current_part = null;
                                }, 300);
                            }
                            this.$store.commit("toggleModalLoader", false);
                        });
                }
            }
        },
        getUnscheduled(furnace = null) {
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "work_orders/batch",
                    method: "get",
                    stateProperty: "unscheduled_work_orders",
                    dataProperty: "work_orders",
                    commit: true,
                    body: { scheduled: 0 },
                })
                .then((data) => {
                    this.makeDraggable();
                });
        },
        prepOrderForDrag(order) {
            return JSON.stringify(order);
        },
        makeDraggable() {
            var items = document.querySelectorAll(".draggable-event");
            for (var i = 0; i < items.length; i++) {
                var e = items[i];
                var item = {
                    element: e,
                    data: JSON.parse(e.getAttribute("data-event")),
                    id: e.getAttribute("data-id"),
                    keepElement: true,
                };
                DayPilot.Scheduler.makeDraggable(item);
            }
        },
        changeDateRange(direction) {
            let start_date = this.$route.query.start_date;
            let end_date = this.$route.query.end_date;
            let chart_start_date = null;
            let chart_end_date = null;
            if (direction == "next") {
                // add a full day to the start date timestamp
                start_date = +start_date + 86400;
                end_date = +end_date + 86400;
                chart_start_date = new Date(start_date * 1000);
                chart_end_date = new Date(end_date * 1000);
            } else if (direction == "prev") {
                start_date = +start_date - 86400;
                end_date = +end_date - 86400;
                chart_start_date = new Date(start_date * 1000);
                chart_end_date = new Date(end_date * 1000);
            } else if (direction == "today") {
                start_date = Math.floor(new Date() / 1000);
                end_date = start_date + 86400;
                chart_start_date = new Date(start_date * 1000);
                chart_end_date = new Date(end_date * 1000);
            }

            this.schedulerChart.update({
                startDate: new DayPilot.Date(start_date * 1000),
                days: 2,
            });
            this.$router.push({
                name: this.$route.name,
                query: {
                    start_date: start_date,
                    end_date: end_date,
                },
            });
            this.getBatchSchedule();
        },
        handleEventClick(info) {
            this.calendar_event_dialog = true;
            this.current_event = info;
            this.current_event_props = info;
            this.current_event_props.work_orders_batches = info.work_orders_batches || [];
        },
        openUnscheduled(event) {
            this.current_event_props = event;
            this.current_event = null;
            this.calendar_event_dialog = true;
        },
        goToBatch(batch) {
            this.$router.push({ name: "batch_line_profile", params: { work_order_id: batch.work_order_id, batch_id: batch.batch_id } });
        },
        onUnscheduleConfirm() {
            this.$store.commit("toggleModalLoader", true);

            this.removeBatchFromSchedule({ work_order_id: this.current_event.work_order_id }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.unscheduleDialog.close();
                    this.calendar_event_dialog = false;
                    this.getUnscheduled();
                    this.getBatchSchedule();
                }
                this.$store.commit("toggleModalLoader", false);
            });
        },
        showPrinter(type) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/batch/${this.current_event.work_order_id}/${type}`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.process_sheet) {
                        this.file_name = data.process_sheet.file_name;
                    } else if (typeof data != "undefined" && data.bill_of_lading) {
                        this.file_name = data.bill_of_lading.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        printLabel(type) {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/batch/${this.current_event.work_order_id}/${type}`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.process_sheet) {
                        this.$refs.print.printReport(data.process_sheet.file_name);
                    } else if (typeof data != "undefined" && data.bill_of_lading) {
                        this.$refs.print.printReport(data.bill_of_lading.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        getBatchSchedule() {
            this.fetchBatchSchedule({ body: { start_date: this.$route.query.start_date, end_date: this.$route.query.end_date } }).then((data) => {
                if (data && data.work_orders) {
                    this.schedulerChart.events.list = [];
                    if (data && data.work_orders) {
                        data.work_orders.forEach((wo) => {
                            this.schedulerChart.events.add({
                                id: DayPilot.guid(),
                                start: new DayPilot.Date(new Date(wo.start.replace(" ", "T") + ":00"), true),
                                end: new DayPilot.Date(new Date(wo.end.replace(" ", "T") + ":00"), true),
                                text: wo.text,
                                resource: wo.furnace_id,
                                data: wo,
                                work_order_id: wo.work_order_id,
                                backColor: wo.color,
                                fontColor: "#ffffff",
                                barHidden: true,
                                html: `<v-layout row wrap class="fc-sticky fc-event-title" v-if="mode == 'schedule'">
											<v-flex column xs6 pt-1 pl-2 align-self-start>
												<span>${wo.name}</span>
												</br>
												<span>${wo.company}</span>
												</br>
												<span>Furn PT# ${wo.pattern_number}</span>
											</v-flex>
											<v-flex column xs6 pt-1 align-self-start>
												<span>${wo.customer_part_number}</span>
												</br>
												<span>Qty ${wo.batch_qty}</span>
											</v-flex>
										</v-layout>
										`,
                            });
                        });
                    }
                    this.schedulerChart.update();
                }
            });
        },
        async refresh(force = false) {
            this.getUnscheduled();

            // this.fetchScheduledBatches({ start_date: this.$route.query.start_date, end_date: this.$route.query.end_date });
            let dis = this;
            if (this.schedulerChart == null) {
                this.schedulerChart = new DayPilot.Scheduler("dp", {
                    timeHeaders: [
                        { groupBy: "Day", format: "dddd, yyyy-MM-dd" },
                        { groupBy: "Hour", format: "H" },
                        { groupBy: "Cell", format: "mm" },
                    ],
                    scale: "CellDuration",
                    cellDuration: 30,
                    days: 2,
                    startDate: DayPilot.Date.today(),
                    timeRangeSelectedHandling: "Disabled",
                    eventResizeHandling: "Disabled",
                    resources: [],
                    events: [],
                    cellWidthSpec: "Fixed",
                    cellWidth: 25,
                    rowMinHeight: 128,
                    eventHeight: 128,
                    height: 650,
                    onEventMoved: function (args) {
                        let current_date_start = dis.$route.query.start_date;
                        let current_date_end = dis.$route.query.end_date;

                        // convert args.newStart to timestamp
                        let start_date = new Date(args.newStart).getTime() / 1000;
                        let new_resource = args.newResource;

                        // save the event to the database
                        dis.saveBatchToSchedule({
                            start_date: current_date_start,
                            end_date: current_date_end,
                            furnace_id: new_resource,
                            work_order_id: args.e.data.work_order_id,
                            body: { start: start_date },
                        }).then((data) => {
                            // iterate through data.workorders and update the Schedule
                            dis.schedulerChart.events.list = [];
                            if (data && data.work_orders) {
                                // remove the object from the unscheduled_work_orders based on args.e.data.work_order_id

                                data.work_orders.forEach((wo) => {
                                    dis.schedulerChart.events.add({
                                        id: DayPilot.guid(),
                                        start: new DayPilot.Date(new Date(wo.start.replace(" ", "T") + ":00"), true),
                                        end: new DayPilot.Date(new Date(wo.end.replace(" ", "T") + ":00"), true),
                                        text: wo.text,
                                        resource: wo.furnace_id,
                                        data: wo,
                                        work_order_id: wo.work_order_id,
                                        backColor: wo.color,
                                        fontColor: "#ffffff",
                                        barHidden: true,
                                        html: `<v-layout row wrap class="fc-sticky fc-event-title" v-if="mode == 'schedule'">
												<v-flex column xs6 pt-1 pl-2 align-self-start>
													<span>${wo.name}</span>
													</br>
													<span>${wo.company}</span>
													</br>
													<span>Furn PT# ${wo.pattern_number}</span>
												</v-flex>
												<v-flex column xs6 pt-1 align-self-start>
													<span>${wo.customer_part_number}</span>
													</br>
													<span>Qty ${wo.batch_qty}</span>
												</v-flex>
											</v-layout>
											`,
                                    });
                                });
                            }
                            dis.schedulerChart.update();
                            dis.getUnscheduled();
                        });
                    },
                    onEventMoving: (args) => {
                        if (args.external == true) {
                            args.end = args.start.addMinutes(30);
                        }
                        let available_resources = args.e.data.data ? args.e.data.data.furnace_id_options.split(",") : args.e.data.furnace_id_options.split(",");
                        if (available_resources.indexOf(args.row.id) == -1) {
                            args.left.enabled = false;

                            args.allowed = false;
                        }
                    },
                    onEventClick: (args) => {
                        dis.handleEventClick(args.e.data.data);
                    },
                });

                this.schedulerChart.init();
            }

            this.$store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    stateProperty: "machines",
                    commit: true,
                    body: JSON.parse(JSON.stringify({ resource: 1, line_id: 1 })),
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.machines) {
                        this.schedulerChart.update({ resources: data.machines });
                    }
                });
            // Scroll to the current date and current time
            this.schedulerChart.scrollTo(new DayPilot.Date());

            this.getBatchSchedule();
        },
    },
    mounted() {
        this.refresh();
    },
    beforeDestroy() {
        this.schedulerChart = null;
    },
};
</script>
